import React from "react";
import { Container, Card, Col, Row } from "react-bootstrap";
import classes from "./Auth.module.css";
import { Link, useNavigate } from "react-router-dom";
import cogoToast from 'cogo-toast';
import { useTranslation, withTranslation } from 'react-i18next'
import { useDispatch } from "react-redux";
import { authLogin } from "../../network/auth";
import queryClient from "../../services/react-query/queryClient";
import { useMutation } from "@tanstack/react-query";
import { setUserData } from "../../services/store/slices/user";
import { queryKeys } from "../../services/react-query/queryKeys";
import { Form, Input, Button } from "antd";

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { mutate: onLogin, isPending } = useMutation({
    mutationFn: (formData) => authLogin(formData),
    onSuccess: (data) => {
      if (data.status === true) {
        queryClient.invalidateQueries([queryKeys.userData]);
        cogoToast.success(t("auth.loginSuccess"), { position: "top-right" });
        dispatch(setUserData(data));
        localStorage.setItem("token", data.token);
        navigate("/");
      } else {
        cogoToast.warn(t("auth.invalidCredentials"), { position: "top-right" });
      }
    },
    onError: () => {
      cogoToast.warn(t("auth.errorOccurred"), { position: "top-right" });
    },
  });

  const onFinish = (values) => {
    onLogin(values);
  };

  return (
    <Container>
      <Row>
        <Col className="mx-auto py-5" xl={8} lg={8} md={8} sm={12}>
          <h4 className={`${classes["auth-header-title"]}`}>
            {t("login1")}
          </h4>
          <div className={`${classes["auth-subheader-title"]}`}>
            {t("login2")}{" "}
            <Link
              to="/register"
              className={`${classes["register-link"]}`}
            >
              {t("signup")}

            </Link>{" "}

            {t("login7")}
          </div>

          <Card className={`${classes["custom-card"]}`}>
            <Card.Body>
              <Row>
                <Col></Col>
                <Col xl={6}>
                  <Form form={form} name="login" onFinish={onFinish} layout="vertical">
                    <Form.Item
                      className={`${classes["form-label"]}`}
                      name="email"
                      label={t("login3")}
                      required={false}
                      rules={[
                        { type: 'email', message: t("auth.emailValidation") },
                        { required: true, message: t("auth.emailValidationRequired") },
                      ]}
                    >
                      <Input placeholder={t("login3")} className={`${classes["form-inputs"]}`} />
                    </Form.Item>
                    <Form.Item
                      required={false}
                      className={`${classes["form-label"]}`}
                      name="password"
                      label={t("login4")}
                      rules={[
                        { required: true, message: t("auth.passwordValidationRequired") },
                      ]}
                      hasFeedback
                    >
                      <Input.Password placeholder={t("login4")} className={`${classes["form-inputs"]}`} />
                    </Form.Item>

                    <Link
                      className={`${classes["forgot-link"]}`}
                      to="/forgot-password"
                    >
                      {t("login6")}
                    </Link>

                    <Button
                      type="primary"
                      loading={isPending}
                      htmlType="submit"
                      className={`${classes["auth-button"]}`}
                    >
                      {t("auth.login")}
                    </Button>
                  </Form>
                </Col>
                <Col></Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}


export default withTranslation()(Login);

